var _defs, _rect, _polygon, _line, _line2, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM3Innehll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "1e7572ba-60e2-4a7b-a0e6-aa743ad69eb6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1438.9 1438.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a2c7c1d0-420f-4f94-889a-7cb975d12348{fill:#fff;stroke-linecap:round;stroke-width:37.5px;}.\\39 242a971-8af6-4057-a0d9-17819372e1e8,.a2c7c1d0-420f-4f94-889a-7cb975d12348,.dfca00f3-989e-406a-9b6d-5ee5aa26840f{stroke:#39526e;stroke-miterlimit:10;}.\\38 ac56832-6641-4b96-ba2f-299405b91efd{fill:#39526e;}.\\39 242a971-8af6-4057-a0d9-17819372e1e8,.dfca00f3-989e-406a-9b6d-5ee5aa26840f{fill:none;stroke-linecap:square;}.\\39 242a971-8af6-4057-a0d9-17819372e1e8{stroke-width:50px;}.dfca00f3-989e-406a-9b6d-5ee5aa26840f{stroke-width:88.17px;}.\\38 c7db1b3-ab44-4f2c-a1f8-70dde58865a3{fill:#eea320;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_UnitRange-M3_1500x1500_Outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a2c7c1d0-420f-4f94-889a-7cb975d12348",
    x: 18.75,
    y: 18.75,
    width: 1401.4,
    height: 1401.4,
    rx: 253.52,
    ry: 253.52
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "8ac56832-6641-4b96-ba2f-299405b91efd",
    points: "1169.56 1046.69 222.9 1046.69 222.9 799.24 545.71 590.58 1169.56 590.58 1169.56 1046.69"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "9242a971-8af6-4057-a0d9-17819372e1e8",
    x1: 234.39,
    y1: 387.94,
    x2: 523,
    y2: 595.46
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "dfca00f3-989e-406a-9b6d-5ee5aa26840f",
    x1: 1082.11,
    y1: 1090.44,
    x2: 1125.47,
    y2: 1090.44
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "dfca00f3-989e-406a-9b6d-5ee5aa26840f",
    cx: 296.21,
    cy: 1106.66,
    r: 22.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "8c7db1b3-ab44-4f2c-a1f8-70dde58865a3",
    d: "M644.45,992.45V719.35h67.61l40.71,186.47,40.4-186.47H861.1v273.1H819V777.29L774.36,992.45h-43.5L686.55,777.29V992.45Z",
    transform: "translate(-34.42 -28.55)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "8c7db1b3-ab44-4f2c-a1f8-70dde58865a3",
    d: "M894.63,920.17,936.17,914q1.68,19.29,10.65,29.48t21.11,10.2q13.26,0,22.42-12.11t9.16-33.53q0-19.93-8.79-31.3T969.4,865.4q-8.22,0-19.63,3.91l4.66-42.66q16.67.38,26.4-8.91,9.54-9.29,9.55-26.2,0-14.12-6.92-22.1a22.44,22.44,0,0,0-17.76-8q-10.85,0-18.79,9.22T937.47,798l-39.68-8.19q6.16-37.44,24.07-54.4t45.14-17q30.59,0,48.59,21.77t18,48.17a64.19,64.19,0,0,1-8.11,32.18q-8.1,14.33-24.31,25.11,18.81,5,30.65,22.17t11.83,42.85q0,37.44-22.29,61.94T968.3,997.1q-29.46,0-49.89-20.63T894.63,920.17Z",
    transform: "translate(-34.42 -28.55)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM3Innehll);
export default __webpack_public_path__ + "static/media/m3innehåll.850d4b6688a7bf0833ddb998c97d45b6.svg";
export { ForwardRef as ReactComponent };